// extracted by mini-css-extract-plugin
module.exports = {"abas":"Abas_abas__1RmXY","aba":"Abas_aba__2kxbS","icone":"Abas_icone__30QNr","ativo":"Abas_ativo__1QQgV"};